import { render, staticRenderFns } from "./TenantBackupRestore.vue?vue&type=template&id=842fd106&"
import script from "./TenantBackupRestore.vue?vue&type=script&lang=js&"
export * from "./TenantBackupRestore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports